exports.DASHBOARD_DROPDOWN_OPTIONS = [
  { label: "All", value: "all" },
  { label: "Reach & Frequecy", value: "rf" },
  { label: "OEM", value: "oem" },
  { label: "VTR", value: "vtr" },
  { label: "BCR", value: "bcr" },
  { label: "Streaming VTR", value: "svtr" }
];

exports.APPLICATION_COLORS = {
  "command-center": "red",
  "samba-data-analytics": "yellow",
  "rt-cid-tv-integrations-webpage": "blue"
};

exports.USERS_HEADER_NAVIGATION_ITEMS = [
  { title: "Samba Employees", query: 'identities.connection: "google-oauth2"' },
  {
    title: "All Users",
    query: 'identities.connection: "Username-Password-Authentication"'
  },
  {
    title: "Real-time TV Users",
    query:
      'app_metadata.application:"real-time-tv-ratings" OR app_metadata.application: "command-center"'
  },
  {
    title: "CID TV Integrations Users",
    query: 'app_metadata.application:"rt-cid-tv-integrations-webpage"'
  }
];
